import styled from '@emotion/styled';
import { ChevronRight } from 'lucide-react';
import { theme } from 'styles/theme/theme';

export const MainBlock = styled.div`
  display: flex;
  flex-direction: column;

  // 36px (UDIconButton size=md) + 6px паддинга с каждой стороны = 48px;
  // gap 4px, чтобы промежуток между самими иконками остался прежним (по 8px внутри кнопки)
  width: 48px;
  padding: 6px;
  gap: 4px;
  border-right: 1px solid ${theme.colors.DarkBlue100};
  background: ${theme.colors.SurfaceWhite};

  align-items: center;
`;
const Button = styled.button`
  border: none;
  background: none;
  cursor: pointer;
`;
export const ModalButton = styled(Button)`
  display: flex;
  align-items: center;
  padding-inline: 20px;
  min-height: 24px;
  padding-block: 8px;
  gap: 8px;

  /* Длинная подпись в две строки не должна сжимать иконку. */
  & > svg {
    flex-shrink: 0;
  }

  &:hover {
    background: ${theme.colors.AccentCornsilk};
  }
`;

export function OpenerIconWrapper({ icon }: { icon: React.ReactNode }) {
  return (
    <div className="flex-center" style={{ position: 'relative', width: 32, height: 32 }}>
      {icon}
      <ChevronRight size={12} style={{ position: 'absolute', right: -5 }} />
    </div>
  );
}
